__turbopack_context__.v({
  "bar": "EL-8xq_bar",
});
